// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M12.5,17h-1V2h1V17z M12.5,20h-1v2h1V20z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-warning--LtOG5CH.js.map
